import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Fi from 'react-icons/fi';

import { Page, Button } from 'ui/components';

import { User, Auth } from 'services/action';

const FinishScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['vendor']);

  const $onFinishOnboarding = async () => {
    const req = await Dispatch(User.$onboarding());

    if (req?.message === 'success') {
      await Dispatch(Auth.$fetchProfile());
    }
  };

  return (
    <Page className="col-12 p-md-4 bg-white h-100" isOnboarding>
      <Page.Header
        className="p-0"
        isOnboarding={
          <div className="py-3 px-0 mt-5 mt-md-0">
            <div
              className="fw-semibold title mb-2 p-0"
              style={{ fontSize: 26 }}
            >
              Selamat,
            </div>
          </div>
        }
      />
      <Page.Body className="p-md-3 px-3 mt-4 mt-md-0">
        <div>
          Anda telah menyelesaikan pengisian data yang diperlukan untuk membantu
          Anda dalam penggunaan{' '}
          <b>
            <i>TMS Envio Logistics</i>
          </b>
          .
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-3"
          loading={StateForm?.loading}
          onClick={() => {
            if (StateTable?.total === 0 || StateTable === null) {
              History.push('/onboarding-vendor');
            } else {
              History.push('/onboarding-driver');
            }
          }}
        >
          Sebelumnya
        </Button>
        <Button
          type="button"
          className="btn-primary py-3"
          loading={StateForm?.loading}
          onClick={$onFinishOnboarding}
        >
          Menuju Dashboard <Fi.FiArrowRight className="ms-2 fw-bold" />
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default FinishScreen;
